<main class="app-shell">
  <app-header></app-header>
  <section class="app-content">
    <router-outlet></router-outlet>
  </section>
  <app-footer></app-footer>
</main>
